import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function AssessmentAppealsPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    ASSESSMENT APPEALS POLICY
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Fair Assessment Review Procedures
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Information Table */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '30%' }}>Lead Responsibility</td>
                          <td style={{ padding: '20px 30px' }}>Laurence T. Sofowora</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '25%' }}>Approved by:</td>
                          <td style={{ padding: '20px 30px' }}>Adekunle Ayeni</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Version</td>
                          <td style={{ padding: '20px 30px' }}>V14 - 2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Date of Approval</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2025</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Effective from</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Next review date</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2026</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}>ALL EMPLOYEES and FREELANCE STAFF</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contents Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '30px', textAlign: 'center' }}>
                    Contents
                  </h3>
                  
                  <div style={{ paddingLeft: '20px' }}>
                    <div style={{ marginBottom: '15px' }}>
                      <span style={{ color: '#334155', fontSize: '1.05rem', fontWeight: '600' }}>1.</span>
                      <span style={{ color: '#334155', fontSize: '1.05rem', marginLeft: '15px' }}>Appeals by Learners</span>
                      <span style={{ float: 'right', color: '#64748b' }}>1</span>
                    </div>
                    
                    <div style={{ marginBottom: '15px', paddingLeft: '30px' }}>
                      <span style={{ color: '#334155', fontSize: '1rem' }}>1.1.</span>
                      <span style={{ color: '#334155', fontSize: '1rem', marginLeft: '15px' }}>Stage 1 – Tutor/Assessor and Learner</span>
                      <span style={{ float: 'right', color: '#64748b' }}>1</span>
                    </div>

                    <div style={{ marginBottom: '15px', paddingLeft: '30px' }}>
                      <span style={{ color: '#334155', fontSize: '1rem' }}>1.2.</span>
                      <span style={{ color: '#334155', fontSize: '1rem', marginLeft: '15px' }}>Stage 2 – Lead Internal Quality Assurer</span>
                      <span style={{ float: 'right', color: '#64748b' }}>1</span>
                    </div>

                    <div style={{ marginBottom: '15px', paddingLeft: '30px' }}>
                      <span style={{ color: '#334155', fontSize: '1rem' }}>1.3.</span>
                      <span style={{ color: '#334155', fontSize: '1rem', marginLeft: '15px' }}>Stage 3 – Appeals Panel</span>
                      <span style={{ float: 'right', color: '#64748b' }}>2</span>
                    </div>

                    <div style={{ marginBottom: '15px', paddingLeft: '20px' }}>
                      <span style={{ color: '#334155', fontSize: '1.05rem' }}>Stage 1 Appeals Procedure</span>
                      <span style={{ float: 'right', color: '#64748b' }}>3</span>
                    </div>

                    <div style={{ paddingLeft: '20px' }}>
                      <span style={{ color: '#334155', fontSize: '1.05rem' }}>Assessment Appeals Form</span>
                      <span style={{ float: 'right', color: '#64748b' }}>4</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 1. Appeals by Learners */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    1. Appeals by Learners
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    This procedure applies specifically to those further education learners who undertake an examination or assessment that is within the control of DTK College.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    As part of the assessment procedure, learners will be asked to sign that they accept and understand their assessment outcomes/grades.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    If a learner believes that they have a justified grievance related to an assessment process or decision, the appeals should follow the process set out below:
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                    1.1. Stage 1 – Tutor/Assessor and Learner
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The learner should discuss the matter with the tutor who undertook the assessment in the first instance within <strong>five</strong> working days of receiving their assessment decision.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The Tutor/Assessor must consider the reasons and look again at the assessment. He or she must then give the learner a response which must be either:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px', paddingLeft: '25px' }}>
                    1.1.1. confirmation in writing that the original assessment decision stands; or
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px', paddingLeft: '25px' }}>
                    1.1.2. a new decision with an explanation of the reason for the change.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The response must be filed either in the Lead Internal Quality Assurer Programme Quality file or electronically (as appropriate).
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    If the learner accepts the tutor's response, then the appeal stops at this point.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    If the learner is still unhappy with the decision, he/she must tell the tutor within five working days of receipt. <strong>The appeal will move to Stage 2.</strong>
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                    1.2. Stage 2 – Lead Internal Quality Assurer (IQA)
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Following notification that the learner is still unhappy with the assessment decision, the tutor must give the IQA the following information within <strong>two</strong> working days of the appeal reaching <strong>Stage 2:</strong>
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px', paddingLeft: '25px' }}>
                    1.2.1. the original assessment record and learner's evidence, where appropriate; and
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', paddingLeft: '25px' }}>
                    1.2.2. the written explanation and confirmation of the assessment decision.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Page 2 Content - Continued Stage 2 and Stage 3 */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The IQA will reconsider the assessment decision, taking the following into account:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px', paddingLeft: '25px' }}>
                    1.2.3. the learner's reason for appeal;
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px', paddingLeft: '25px' }}>
                    1.2.4. the learner's evidence and associated records;
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px', paddingLeft: '25px' }}>
                    1.2.5. the assessor's reason for the decision; and
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px', paddingLeft: '25px' }}>
                    1.2.6. the opinion of another assessor from the centre.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The IQA must then give the reconsidered decision, in writing, within <strong>five</strong> working days of receiving the appeal, to both learner and Tutor.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    The learner must tell the IQA and confirm in writing if they are still unhappy with the reconsidered assessment decision within <strong>five</strong> working days of receipt of the decision. If so, the appeal moves to <strong>Stage 3.</strong>
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                    1.3. Stage 3 – Appeals Panel
                  </h4>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    If the learner is dissatisfied with the decision after Stage 2, they have the right to go to an Appeals Panel. The staff member who conducted the Stage 2 process must send the following details to the Quality Nominee:
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px', paddingLeft: '25px' }}>
                    1.3.1. the written explanation and confirmation of the assessment decision;
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px', paddingLeft: '25px' }}>
                    1.3.2. the assessment record sheets; and
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px', paddingLeft: '25px' }}>
                    1.3.3. any written comments.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Within <strong>ten</strong> working days of receiving the appeal, the Quality Nominee will convene a College Appeals Panel to hear the appeal. The Appeals Panel will consist of the Quality Nominee, a subject expert chosen by the Chair (internal or external to the college) and the Head of the department concerned.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The learner may speak to the Appeals Panel and may be accompanied by an adviser*, and/or make a written submission. The tutor who made the original decision will be asked to attend the Appeals Panel to answer questions.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The Appeals Panel will then discuss the matter in private and reach a majority decision. All parties will then be informed of the decision.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The decision of the Appeals Panel is final, although learners may appeal to the Awarding Body once the internal appeals decision has been completed. Set out below is a flow chart of the Learner Appeals Process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stage 1 Appeals Procedure Flowchart */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="text-center mb-4">
                    <div className="d-inline-block p-3" style={{
                      backgroundColor: '#fef3c7',
                      borderRadius: '8px',
                      border: '2px solid #f59e0b'
                    }}>
                      <h4 style={{ color: '#0369a1', fontSize: '1.4rem', fontWeight: '700', marginBottom: '0' }}>
                        Stage 1 Appeals Procedure
                      </h4>
                    </div>
                  </div>

                  {/* Flowchart */}
                  <div style={{ padding: '30px 20px', maxWidth: '700px', margin: '0 auto' }}>
                    {/* Start */}
                    <div className="text-center mb-2">
                      <div className="p-3" style={{
                        border: '2px solid #1e293b',
                        borderRadius: '4px',
                        backgroundColor: '#fff'
                      }}>
                        <span style={{ fontSize: '0.95rem', color: '#1e293b' }}>Assessment takes place</span>
                      </div>
                    </div>

                    {/* Arrow */}
                    <div className="text-center mb-2">
                      <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                    </div>

                    {/* Assessor gives feedback */}
                    <div className="text-center mb-2">
                      <div className="p-3" style={{
                        border: '2px solid #1e293b',
                        borderRadius: '4px',
                        backgroundColor: '#fff'
                      }}>
                        <span style={{ fontSize: '0.95rem', color: '#1e293b' }}>Assessor gives feedback</span>
                      </div>
                    </div>

                    {/* Split arrows */}
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px', position: 'relative' }}>
                      <div style={{ width: '50%', textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                      </div>
                      <div style={{ width: '50%', textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                      </div>
                    </div>

                    {/* Two boxes side by side */}
                    <div className="row g-3 mb-2">
                      <div className="col-6">
                        <div className="text-center p-3" style={{
                          border: '2px solid #1e293b',
                          borderRadius: '4px',
                          backgroundColor: '#fff',
                          minHeight: '100px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <div>
                            <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1', marginBottom: '8px' }}>↓</div>
                            <span style={{ fontSize: '0.85rem', color: '#1e293b' }}>Learner agrees with result</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="text-center p-3" style={{
                          border: '2px solid #1e293b',
                          borderRadius: '4px',
                          backgroundColor: '#fff',
                          minHeight: '100px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <span style={{ fontSize: '0.85rem', color: '#1e293b' }}>Learner disagrees with result</span>
                        </div>
                      </div>
                    </div>

                    {/* Continue flow on right side */}
                    <div style={{ position: 'relative', marginLeft: '50%' }}>
                      <div className="text-center mb-2">
                        <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                      </div>

                      <div className="text-center mb-2">
                        <div className="p-3" style={{
                          border: '2px solid #1e293b',
                          borderRadius: '4px',
                          backgroundColor: '#fff'
                        }}>
                          <span style={{ fontSize: '0.85rem', color: '#1e293b' }}>Learner discuss with tutor / reason for appeal</span>
                        </div>
                      </div>

                      <div className="text-center mb-2">
                        <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                      </div>

                      <div className="text-center mb-2">
                        <div className="p-3" style={{
                          border: '2px solid #1e293b',
                          borderRadius: '4px',
                          backgroundColor: '#fff'
                        }}>
                          <span style={{ fontSize: '0.85rem', color: '#1e293b' }}>Tutor considers reason and gives new decision or confirms original decision</span>
                        </div>
                      </div>

                      <div className="text-center mb-2">
                        <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                      </div>

                      <div className="text-center mb-2">
                        <div className="p-3" style={{
                          border: '2px solid #1e293b',
                          borderRadius: '4px',
                          backgroundColor: '#fff'
                        }}>
                          <span style={{ fontSize: '0.85rem', color: '#1e293b', fontWeight: '600' }}>STAGE 2<br/>Lead IV's opinion sought</span>
                        </div>
                      </div>

                      <div className="text-center mb-2">
                        <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                      </div>

                      <div className="text-center mb-2">
                        <div className="p-3" style={{
                          border: '2px solid #1e293b',
                          borderRadius: '4px',
                          backgroundColor: '#fff'
                        }}>
                          <span style={{ fontSize: '0.85rem', color: '#1e293b' }}>Lead IV considers reasons and seeks opinion of other assessor from the centre</span>
                        </div>
                      </div>
                    </div>

                    {/* Reconnect with left side */}
                    <div style={{ position: 'relative' }}>
                      {/* Arrow coming back to center */}
                      <div className="text-center mb-2">
                        <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                      </div>

                      <div className="row g-3 mb-2">
                        <div className="col-6">
                          <div className="text-center p-3" style={{
                            border: '2px solid #1e293b',
                            borderRadius: '4px',
                            backgroundColor: '#fff'
                          }}>
                            <span style={{ fontSize: '0.85rem', color: '#1e293b' }}>Learner agrees with result</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="text-center p-3" style={{
                            border: '2px solid #1e293b',
                            borderRadius: '4px',
                            backgroundColor: '#fff'
                          }}>
                            <span style={{ fontSize: '0.85rem', color: '#1e293b', fontWeight: '600' }}>STAGE 3<br/>Appeals Panel called. Quality Nominee & curriculum AP. Decision final</span>
                          </div>
                        </div>
                      </div>

                      {/* Final stage */}
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                        <div style={{ width: '48%', textAlign: 'center' }}>
                          <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1', marginBottom: '8px' }}>↓</div>
                          <div className="p-2" style={{
                            border: '2px solid #1e293b',
                            borderRadius: '4px',
                            backgroundColor: '#fff'
                          }}>
                            <span style={{ fontSize: '0.85rem', color: '#1e293b' }}>Results confirmed and records completed</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Assessment Appeals Form */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="text-center mb-4">
                    <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '0' }}>
                      Assessment Appeals Form
                    </h3>
                  </div>

                  {/* Form Table */}
                  <div className="table-responsive">
                    <table className="table table-bordered" style={{ fontSize: '0.95rem' }}>
                      <tbody>
                        <tr>
                          <td style={{ padding: '15px', backgroundColor: '#f8fafc', width: '50%', fontWeight: '500' }}>Name of Learner:</td>
                          <td style={{ padding: '15px' }}>Programme Title:</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px', backgroundColor: '#f8fafc', fontWeight: '500' }}>Name of Assessor:</td>
                          <td style={{ padding: '15px' }}>Name of IQA:</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px', backgroundColor: '#f8fafc', fontWeight: '500' }}>Date of Assessment:</td>
                          <td style={{ padding: '15px' }}>Curriculum Area:</td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ padding: '15px', backgroundColor: '#f8fafc', fontWeight: '500' }}>Unit and criteria covered by assessment activity:</td>
                        </tr>

                        {/* Stage 1 */}
                        <tr>
                          <td colSpan="2" style={{ padding: '15px', backgroundColor: '#FAF8FC', fontWeight: '600', textAlign: 'center' }}>Stage 1</td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ padding: '15px' }}>
                            <strong>Stage 1: Assessor's Comments</strong><br/>
                            Assessment details:<br/><br/><br/><br/>
                            <div style={{ textAlign: 'right', marginTop: '20px' }}>
                              Final Grade: <span style={{ border: '1px solid #000', padding: '5px 20px', display: 'inline-block' }}></span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ padding: '15px', backgroundColor: '#f8fafc', fontWeight: '500' }}>Learner's reason for appeal:</td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ padding: '50px 15px' }}></td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Learner's signature: ................................................</td>
                          <td style={{ padding: '15px' }}>Date: .............................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Assessor's signature: ................................................</td>
                          <td style={{ padding: '15px' }}>Date: .............................................</td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ padding: '15px', backgroundColor: '#f8fafc', fontWeight: '500' }}>Assessor's decision based on Stage 1 procedure:</td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ padding: '50px 15px' }}></td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Date letter of appeal received: .........................................</td>
                          <td style={{ padding: '15px' }}>Acknowledgement letter sent <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Copy of letter and stage 1 notes sent to:</td>
                          <td style={{ padding: '15px' }}>Date:</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Internal Quality Assurer <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Lead Internal Quality Assurer <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Curriculum Manager <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Director, Studies <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>

                        {/* Stage 2 */}
                        <tr>
                          <td colSpan="2" style={{ padding: '15px', backgroundColor: '#FAF8FC', fontWeight: '600', textAlign: 'center' }}>Stage 2</td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ padding: '15px', backgroundColor: '#f8fafc', fontWeight: '500' }}>Stage 2: Lead Internal Quality Assurer's comments:</td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ padding: '50px 15px' }}></td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Signature: .....................................................</td>
                          <td style={{ padding: '15px' }}>Date: ................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Outcome of Stage 2 appeal sent to:</td>
                          <td style={{ padding: '15px' }}>Date</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Lead Internal Quality Assurer <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Curriculum Manager <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Director, Teaching & Learning <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ padding: '15px', textAlign: 'right' }}>
                            Final Assessment Decision: <span style={{ border: '1px solid #000', padding: '5px 20px', display: 'inline-block', marginLeft: '10px' }}></span>
                          </td>
                        </tr>

                        {/* Stage 3 */}
                        <tr>
                          <td colSpan="2" style={{ padding: '15px', backgroundColor: '#FAF8FC', fontWeight: '600', textAlign: 'center' }}>Stage 3</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Date of Stage 3 letter of appeal received:</td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Acknowledgement letter sent: <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}></td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Appeal Panel Date:</td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Chair of Appeals Panel:</td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Members of Appeals Panel:</td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Invitation to appeals panel sent: <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}></td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ padding: '15px', backgroundColor: '#f8fafc', fontWeight: '500' }}>Comments (Appeals Panel)</td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ padding: '50px 15px' }}></td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Chair of Appeals Panel Signature ................................</td>
                          <td style={{ padding: '15px' }}>Date: ........................</td>
                        </tr>
                        <tr>
                          <td colSpan="2" style={{ padding: '15px', textAlign: 'right' }}>
                            Final Assessment Decision: <span style={{ border: '1px solid #000', padding: '5px 20px', display: 'inline-block', marginLeft: '10px' }}></span>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Outcome of Appeals Panel (Stage 3) sent to:</td>
                          <td style={{ padding: '15px' }}>Date:</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Learner <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Tutor/Assessor <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Lead IV <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Curriculum Manager <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Quality Nominee <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Entered on Appeals Record Log <span style={{ border: '1px solid #000', padding: '2px 10px', marginLeft: '10px' }}></span></td>
                          <td style={{ padding: '15px' }}></td>
                        </tr>
                        <tr>
                          <td style={{ padding: '15px' }}>Date Appeal Logged:</td>
                          <td style={{ padding: '15px' }}>........................................................</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default AssessmentAppealsPolicy;